// extracted by mini-css-extract-plugin
module.exports = {"swiss_medical_center_page__lead":"SwissMedicalCenterPage_swiss_medical_center_page__lead__2QM9n"};